"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.identify = exports.initialize = void 0;
const LDClient = __importStar(require("launchdarkly-js-client-sdk"));
const utils_1 = require("./utils");
let client;
async function initialize(key, context, options) {
    if (context.anonymous) {
        (0, utils_1.showWarning)('context.anonymous flag was set to false automatically');
    }
    client = LDClient.initialize(key, { ...context, anonymous: false }, options);
    await client.waitForInitialization();
    return client;
}
exports.initialize = initialize;
async function identify(context, hash, onDone) {
    if (context.anonymous) {
        (0, utils_1.showWarning)('context.anonymous flag was set to false automatically');
    }
    if (!client) {
        (0, utils_1.throwError)('Launchdarkly was not initialized');
    }
    return client.identify({ ...context, anonymous: false }, hash, onDone);
}
exports.identify = identify;
